import { Box } from '@mui/material';
import { DecksGraph } from './DecksGraph';
import { DecksTable } from './DecksTable';

export const DecksContainer = () => {
  return (
    <Box sx={{ mt: 4, mb: 2, pb: 4 }}>
      <DecksGraph />
      <DecksTable />
    </Box>
  );
};
